import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class PriceInformation extends Component {

    static propTypes = {
        priceInformation: PropTypes.string,
    };

    initialState = {
        hoverActive: false
    };

    constructor() {
        super();
        this.state = this.initialState;
    }

    onMouseIn = () => {
        this.setState({hoverActive: true})
    };

    onMouseOut = () => {
        this.setState({hoverActive: false})
    };

	render() {
        const {priceInformation} = this.props;
        const {hoverActive} = this.state;

        const priceInformationOutput = (
            <div className="priceInformationCol">
                <span className="priceInformation priceInformationIcon" onMouseEnter={this.onMouseIn} onMouseLeave={this.onMouseOut} onClick={e => e.preventDefault()} > </span>

                {hoverActive &&
                    <div className="tooltipInner">
                        <div className="tooltipText">
                            {priceInformation}
                        </div>
                    </div>
                }
            </div>
		);

        return priceInformation ? priceInformationOutput : '';
	}
}



// WEBPACK FOOTER //
// ./src/components/Planner/PriceInformation.js